var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 50 } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("i", { staticClass: "fa fa-download" }),
        _c(
          "span",
          { staticClass: "download", on: { click: _vm.downloadGeometrias } },
          [
            _vm._v(
              "Download - Geometria de processos indeferidos e títulos cancelados."
            )
          ]
        )
      ]),
      _c("el-col", { attrs: { span: 24 } }, [
        _c("i", { staticClass: "fa fa-download" }),
        _c(
          "span",
          { staticClass: "download", on: { click: _vm.downloadProcesso } },
          [
            _vm._v(
              "Download - Planilha de processos indeferidos e títulos cancelados."
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00c2f7d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00c2f7d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/AppMonitoramentoDeClausulasResolutivas.vue
// module id = null
// module chunks = 